import { inject, Injectable } from '@angular/core';
import { BaseHttpService } from './base.http.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NmaDoaService {

  baseHttpService = inject(BaseHttpService);

  constructor() { }  

  doaByType(employeeNumber: string, type: string): Observable<number> {

    let params = new HttpParams();
    
    if (employeeNumber) params = params.set('employeeNumber', employeeNumber);
    if (type) params = params.set('type', type);
    return this.baseHttpService.get<number>('/doaByType', { params });
  }
  
}
